import { toColorString } from "polished";
import { isValidRgb } from "./isValidRgb";
import { Rgb } from "../types";

const ensureHexStartsWithPoundSign = (hex: string) => {
  return hex.startsWith("#") ? hex : `#${hex}`;
};

type determineBackgroundColorArgs = {
  hex?: string;
  rgb?: Rgb;
};

export const getBackgroundColor = ({
  hex,
  rgb,
}: determineBackgroundColorArgs) => {
  if (isValidRgb(rgb)) {
    return toColorString(rgb);
  }

  if (hex) {
    return ensureHexStartsWithPoundSign(hex);
  }

  return "#FFFFFF";
};
